import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Header } from '../../compositions';
import { common, cards } from '../../helpers/api';
import { PageContainer } from '../common';
import { Loader } from '../../components';
import ValidateCardForm from '../../components/forms/ValidateCardForm';
import GirlSmilingImg from '../../assets/vrpat/mulher-sorrindo-com-notebook.png';
import devices from '../../styles/devices';
import { ToastCtx } from '~/providers/ToastProvider';
import messages from '../../helpers/api/messages';
import { updateUser } from '~/store/modules/user/actions';
import { openModal } from '~/store/modules/modal/actions';
import { VRPAT } from '~/config/constants';

const ValidateCardContainer = styled(PageContainer)`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-around;

  @media (min-width: ${devices?.desktop}) {
    flex-direction: row;
    align-items: center;
    height: 100vh;
  }
`;
const HeaderContainer = styled.div`
  padding: 21px 21px 0 21px;
`;
const Image = styled.img`
  width: 80%;
  max-width: 565px;
  align-self: flex-start;

  @media (min-width: ${devices.mobile}) {
    width: 100%;
    align-self: center;
  }
`;
const FormContainer = styled.div`
  margin-top: -70px;

  @media (min-width: ${devices?.desktop}) {
    margin-top: 0;
  }
`;
const QuickSearchLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: underline;
`;

export default function ValidateCard() {
  const [isLoading, setIsLoading] = useState(false);
  const [reCaptchaKey, setReCaptchaKey] = useState('');
  const user = useSelector(state => state.user);
  const issuer = useSelector(state => state?.issuer);
  const dispatch = useDispatch();
  const history = useHistory();
  const toast = useContext(ToastCtx);

  // eslint-disable-next-line
  async function getReCaptchaKey() {
    try {
      setIsLoading(true);
      const response = await common.getReCaptchaKey();
      const { result } = response;

      setReCaptchaKey(result?.secretKey);
    } catch (e) {
      toast.dispatch(messages(e, 'recaptcha'));
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (!reCaptchaKey) {
      getReCaptchaKey();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateUserData() {
    const updateAccess = { firstAccess: false };
    dispatch(updateUser(updateAccess));
  }

  function handleClickLink() {
    toast.close();
    dispatch(openModal('quick_search'));
  }

  function msgInvalidCard() {
    return (
      <>
        <strong>Número inválido!</strong>
        <p>
          Se o erro persistir, confirme se sua data de nascimento cadastrada no
          Portal é a mesma informada pelo seu RH.{' '}
        </p>
        <p>
          Para consultar um <strong> cartão provisório</strong> acesse:&nbsp;
          <QuickSearchLink
            aria-label="Buscar cartão provisório"
            onClick={() => handleClickLink()}
          >
            Consultar cartão provisório
          </QuickSearchLink>
        </p>
      </>
    );
  }

  async function handleSubmit(lastDigits) {
    if (isLoading) {
      return;
    }

    const payload = {
      cpf: user?.cpf,
      email: user?.email,
      lastDigits,
    };

    try {
      setIsLoading(true);
      await cards.validateCard(payload);
      updateUserData();
      history.push('/home');
    } catch (e) {
      toast.dispatch(messages(e, 'validate_card', msgInvalidCard()));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <HeaderContainer>
        <Header />
      </HeaderContainer>
      <ValidateCardContainer>
        {issuer?.name === VRPAT && (
          <Image
            aria-label="imagem de uma mulher"
            src={GirlSmilingImg}
            alt="Mulher sorridente sentada com as pernas cruzadas e um notebook em seu colo. Ela está olhando para frente e usando um laço na cabeça, camiseta, calça jeans e tênis."
          />
        )}
        <FormContainer>
          <Loader isLoading={isLoading}>
            <ValidateCardForm
              issuer={issuer}
              submit={handleSubmit}
              reCaptchaKey={reCaptchaKey}
            />
          </Loader>
        </FormContainer>
      </ValidateCardContainer>
    </>
  );
}
